function isMobileSearchViewport() {
  return window.innerWidth <= 960;
}

var syncingSearchInputs = false;
var searchShowDebounceTimer = null;
var SEARCH_DEBOUNCE_MS = 300;

window.SEARCH_DEBOUNCE_MS = SEARCH_DEBOUNCE_MS;

function syncSearchInputs(sourceInput, preferExistingValue) {
  if (syncingSearchInputs || !sourceInput) return;

  syncingSearchInputs = true;
  var inputs = document.querySelectorAll('.search__input');
  var value = sourceInput.value;

  if (preferExistingValue) {
    inputs.forEach(function(input) {
      if (input.value.trim() !== '') {
        value = input.value;
      }
    });
  }

  inputs.forEach(function(input) {
    if (input.value !== value) {
      input.value = value;
    }
  });

  syncingSearchInputs = false;
}

window.syncSearchInputs = syncSearchInputs;

function updateMobileSearchShowClass(searchInput, immediate) {
  if (!isMobileSearchViewport() || !searchInput) return;

  if (searchInput.closest('.mobile-menu')) {
    return;
  }

  clearTimeout(searchShowDebounceTimer);

  if (searchInput.value.trim() === '') {
    document.body.classList.remove('search--show');
    return;
  }

  if (immediate) {
    document.body.classList.add('search--show');
    return;
  }

  searchShowDebounceTimer = setTimeout(function() {
    var activeInput = document.querySelector('.search__input:focus') || searchInput;
    if (activeInput && activeInput.value.trim() !== '') {
      document.body.classList.add('search--show');
    }
  }, SEARCH_DEBOUNCE_MS);
}

window.updateMobileSearchShowClass = updateMobileSearchShowClass;

function clearAllSearchInputs() {
  clearTimeout(searchShowDebounceTimer);
  document.body.classList.remove('search--show', 'mobile-menu-search-active');
  $('.search-results').hide();

  syncingSearchInputs = true;
  document.querySelectorAll('.search__input').forEach(function(input) {
    input.value = '';
  });
  syncingSearchInputs = false;
  var firstInput = document.querySelector('.search__input');
  if (firstInput) {
    firstInput.dispatchEvent(new Event('input', { bubbles: true }));
  }
}

window.clearAllSearchInputs = clearAllSearchInputs;

$(document).on('click', '.search__trigger, .search__close, .js-show-search', function(e) {
  e.preventDefault();
  var isClose = $(this).hasClass('search__close');

  if (!isMobileSearchViewport()) {
    $('body').toggleClass('search--show');
  } else if (isClose) {
    clearTimeout(searchShowDebounceTimer);
    $('body').removeClass('search--show');
    clearAllSearchInputs();
  }

  if (!isClose) {
    $('.search__input').focus();
  }
})

$(document).on('input', '.search__input', function() {
  syncSearchInputs(this, false);
  updateMobileSearchShowClass(this, false);
});

$(document).on('focus', '.search__input', function() {
  syncSearchInputs(this, true);
  updateMobileSearchShowClass(this, this.value.trim() !== '');

  if (isMobileSearchViewport() && this.value.trim() !== '' && this.closest('.mobile-menu')) {
    $(this).trigger('input');
  }
});



function isTouchDevice() {
  return (('ontouchstart' in window) ||
     (navigator.maxTouchPoints > 0) ||
     (navigator.msMaxTouchPoints > 0));
}

function productHover(parent) {
  // parent.querySelectorAll(".product-item").forEach(function(el){
  //   var hoverTl = gsap.timeline({
  //     paused: true,
  //   });

  //   hoverTl.fromTo(el.querySelector(".product-img"), {
  //     autoAlpha: 1,
  //   }, {
  //     autoAlpha: 0,
  //     duration: .15,
  //     ease: "power2.out",
  //   }, 0);

  //   hoverTl.fromTo(el.querySelector(".product-img-hover"), {
  //     scale: 1.2,
  //   }, {
  //     scale: 1,
  //     duration: .25,
  //     ease: "power2.in"
  //   }, 0);

  //   hoverTl.fromTo(el.querySelector(".product-img-hover"), {
  //     autoAlpha: 0,
  //   }, {
  //     autoAlpha: 1,
  //     duration: .5,
  //     ease: "power2.in"
  //   }, .0);

  //   el.addEventListener('mouseenter', function(){
  //     if(window.innerWidth >= 768) hoverTl.play();
  //   });
  //   el.addEventListener('mouseleave', function(){
  //     if(window.innerWidth >= 768) hoverTl.reverse();
  //   });
  // });
}